import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { MapPin, Clock, Briefcase, Search } from 'lucide-react';
import { getJobs } from '../services/api';
import LocationAutocomplete from '../components/LocationAutocomplete';

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get('search') || '');
  const [locationFilter, setLocationFilter] = useState(searchParams.get('location') || '');
  const [categoryFilter, setCategoryFilter] = useState(searchParams.get('category') || '');

  useEffect(() => {
    getJobs().then(res => {
      setJobs(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = jobs;
    if (search) {
      const s = search.toLowerCase();
      result = result.filter(j =>
        j.title.toLowerCase().includes(s) ||
        j.company.toLowerCase().includes(s) ||
        (j.description && j.description.toLowerCase().includes(s))
      );
    }
    if (locationFilter) {
      result = result.filter(j => j.location.toLowerCase().includes(locationFilter.toLowerCase()));
    }
    if (categoryFilter) {
      result = result.filter(j => j.category && j.category.toLowerCase().includes(categoryFilter.toLowerCase()));
    }
    setFiltered(result);
  }, [jobs, search, locationFilter, categoryFilter]);

  return (
    <>
      <div className="page-header">
        <h1>Job Openings</h1>
        <p>Discover your next career opportunity from our latest listings</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Jobs</span>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <div style={{ display: 'flex', gap: 16, marginBottom: 32, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200, position: 'relative' }}>
              <Search size={18} style={{ position: 'absolute', left: 14, top: 14, color: '#94a3b8' }} />
              <input
                type="text"
                placeholder="Search jobs..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ width: '100%', padding: '12px 16px 12px 42px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: '0.938rem', fontFamily: 'inherit', outline: 'none' }}
              />
            </div>
            <LocationAutocomplete
              value={locationFilter}
              onChange={setLocationFilter}
              placeholder="All Locations"
              className="filter-location-autocomplete"
            />
            <select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}
              style={{ padding: '12px 16px', border: '1px solid #e2e8f0', borderRadius: 8, fontSize: '0.938rem', fontFamily: 'inherit', minWidth: 160, outline: 'none', background: 'white' }}>
              <option value="">All Categories</option>
              <option>IT/Software</option>
              <option>HR/Admin</option>
              <option>Marketing</option>
              <option>Finance</option>
              <option>Engineering</option>
              <option>Sales</option>
            </select>
          </div>

          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : filtered.length === 0 ? (
            <div className="empty-state">
              <Briefcase size={64} />
              <h3>No jobs found</h3>
              <p>Try adjusting your search filters</p>
            </div>
          ) : (
            <>
              <p style={{ marginBottom: 20, color: '#64748b' }}>{filtered.length} job{filtered.length !== 1 ? 's' : ''} found</p>
              <div className="jobs-grid">
                {filtered.map(job => (
                  <div className="job-card" key={job.id}>
                    <div className="job-card-header">
                      <div>
                        <h3>{job.title}</h3>
                        <div className="company">{job.company}</div>
                      </div>
                      <span className="job-type-badge">{job.type}</span>
                    </div>
                    <div className="job-meta">
                      <div className="job-meta-item"><MapPin size={16} /> {job.location}</div>
                      <div className="job-meta-item"><Clock size={16} /> {job.experience}</div>
                      <div className="job-meta-item"><Briefcase size={16} /> {job.category}</div>
                    </div>
                    <div className="job-card-footer">
                      <span className="job-salary">{job.salary}</span>
                      <Link to={`/jobs/${job.id}`} className="btn-apply">View & Apply</Link>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
